// Utility functions for QuickBooks service

// Calculate token expiration time
export const calculateExpirationTime = (expiresIn) => {
  const expiresAt = new Date();
  expiresAt.setSeconds(expiresAt.getSeconds() + expiresIn);
  return expiresAt;
};

// Create Basic Auth credentials
export const createBasicAuthCredentials = (clientId, clientSecret) => {
  return btoa(`${clientId}:${clientSecret}`);
};

// Create token info object
export const createTokenInfo = (responseData, realmId) => {
  return {
    accessToken: responseData.access_token,
    refreshToken: responseData.refresh_token,
    companyId: realmId, // QuickBooks Company ID (was realmId)
    expiresAt: calculateExpirationTime(responseData.expires_in),
    refreshTokenExpiresIn: responseData.x_refresh_token_expires_in,
    createdAt: new Date(),
    isActive: true
  };
};

// Create refresh token response
export const createRefreshTokenResponse = (responseData) => {
  return {
    accessToken: responseData.access_token,
    refreshToken: responseData.refresh_token,
    expiresAt: calculateExpirationTime(responseData.expires_in),
    refreshTokenExpiresIn: responseData.x_refresh_token_expires_in
  };
};

// Create connection data for API
export const createConnectionData = (tokenInfo) => {
  return {
    access_token: tokenInfo.accessToken,
    refresh_token: tokenInfo.refreshToken,
    company_id: tokenInfo.companyId,
    expires_at: tokenInfo.expiresAt.toISOString(),
    refresh_token_expires_in: tokenInfo.refreshTokenExpiresIn,
    is_active: true
  };
};

// Handle connection check errors
export const handleConnectionError = (error, franchiseeId) => {
  if (error.response?.status === 404) {
    console.log(`No QuickBooks connection found for franchisee ${franchiseeId}`);
    return false;
  } else if (error.response?.status === 403) {
    console.warn(`Access denied checking QuickBooks connection for franchisee ${franchiseeId}`);
    return false;
  } else if (error.code === 'ECONNREFUSED' || error.code === 'NETWORK_ERROR') {
    console.warn('Backend connection unavailable, assuming no QuickBooks connection');
    return false;
  } else {
    console.warn(`Error checking QuickBooks connection for ${franchiseeId}:`, error.message);
    return false; // Default to no connection on any error
  }
};